import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSimpleiconsComponent } from './simple-icons-simpleicons.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSimpleiconsComponent ],
    exports:      [ SimpleIconsSimpleiconsComponent ],
    bootstrap:    []
})
export class SimpleIconsSimpleiconsModule {}
